import { UseFormRegister, FieldValues, FieldErrors } from "react-hook-form";
import { Rules } from "../../types/integrations";
import { Textarea } from "../ui/textarea";
import { Field, FieldLabel, FieldError } from "../ui/field";

interface TextAreaProps {
  label: string;
  placeholder: string;
  name: string;
  register: UseFormRegister<FieldValues>;
  rules: Rules;
  errors: FieldErrors<FieldValues>;
}

export const FormTextArea = ({
  label,
  placeholder,
  name,
  register,
  rules,
  errors,
}: TextAreaProps) => {
  return (
    <Field>
      <FieldLabel htmlFor={name}>
        {label}
      </FieldLabel>
      <Textarea 
        id={name}
        placeholder={placeholder} 
        {...register(name, rules)}
        aria-invalid={!!errors[name]}
      />
      {errors[name] && (
        <FieldError>{`${errors[name]?.message}`}</FieldError>
      )}
    </Field>
  );
};
